import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../axios/axiosBaseQuery';
import { NewsArticle } from './models/newsArticlesModels';

export const newsArticlesApi = createApi({
  reducerPath: 'newsArticlesApi',
  baseQuery: axiosBaseQuery<NewsArticle[]>(),
  endpoints: (builder) => ({
    fetchNewsArticles: builder.query<NewsArticle[], void>({
      query: () => ({
        url: `${window.config.connectBaseApiUrl}/api/newsfeed`,
      }),
    }),
  }),
});

export const { useFetchNewsArticlesQuery } = newsArticlesApi;
